import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const ProtectedRoute = ({ children, requireAdmin = false, module = null }) => {
  const { user, loading, isAdmin, isGuest, isMasterAdmin, entitlements } = useAuth();
  const location = useLocation();

  // If user was passed from AuthCallback, use it directly
  if (location.state?.user) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground font-body">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Block guests from admin routes
  if (requireAdmin && (isGuest || !isAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Platform-module gate. Master Admins and legacy tenants always pass.
  // When the entitlements snapshot hasn't loaded yet we allow through to
  // avoid blocking on first paint; the snapshot drives the decision once
  // present.
  if (module && !isMasterAdmin && !entitlements?.is_legacy) {
    const pm = entitlements?.platform_modules;
    if (Array.isArray(pm) && !pm.includes(module)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
